import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import whimmLogo from 'assets/whimm-new-logo.png'
import { media } from 'components/styles'

const Image = styled.img`
  width: auto;
  ${media.small`height: 30px; margin: 15px 80px 15px 35px;`}
  ${media.huge`height: 36px; margin: 12px 100px 12px 43px;`}
`

class Logo extends Component {
  render () {
    return <Image onClick={this.props.onClick} src={whimmLogo} />
  }
}

Logo.defaultProps = {
  onClick: () => null
}

Logo.propTypes = {
  onClick: PropTypes.func
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo.js